export default "{{ timeRemaining$ | async | date:'mm:ss' }}\n";